import React, { Component } from "react";
import {
  EmptyState
} from "@shopify/polaris";

//翻译包
import Language from '../../i18n/Language';
const t = Language

class EmptyTableTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.content,
      overview: this.props.overview,
      mixheight: this.props.mixheight,
    };
  }

  render() {
    const {
      state: {
        content,
        overview,
        mixheight
      },
    } = this;
    var className = "emptyWithImg_EmptyState DetailReport_Empty_" + mixheight
    return (
      <div className={className}>
        <EmptyState
          heading={content ? content : t("No data to show here")}
          image="/emptyNew.svg"
          fullWidth
        >
          {overview ? <p>{overview}</p> : null}
        </EmptyState>
      </div>
    );
  }
}

export default EmptyTableTip;



